<template>
  <c-container form v-if="license">
    <c-license-group
      :license="license"
      :running="running"
      :errors="errors"
      @submit="onSubmit"
    >
      <!-- タイトル -->
      <template #title>運転免許証情報を変更</template>

      <!-- 説明文 -->
      <template>
        <p>
          運転免許証の情報を入力して下さい。
        </p>
      </template>

      <template #submit-text>変更</template>
    </c-license-group>
  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CLicenseGroup from '@/pages/register/License/CLicenseGroup'

import * as api from '@/api'
import { run } from '@/libs/a'

export default {
  name: 'License',
  mixins: [
    page('運転免許証情報を設定')
  ],
  components: {
    CLicenseGroup
  },

  /**
   * データ取得
   */
  async prepare (to, from, store) {
    // ログイン中のユーザID を取得する
    const userID = store.getters['user/id']
    if (!userID) {
      throw new Error('The user is not logged in.')
    }

    // 免許証情報を取得する
    const resp = await api.getUserLicense(userID)

    return {
      userID: resp.data.id,
      license: resp.data.license
    }
  },

  props: {
    userID: Number,
    license: Object
  },

  data: () => ({
    // エラー
    errors: [],

    // 処理中
    running: false
  }),

  methods: {
    /**
     * フォームが入力された
     */
    onSubmit (form) {
      run(async () => {
        this.running = true

        const result = await api.putUserLicense(this.userID, {
          license: form
        })

        console.log(result)

        // エラーがあれば表示する
        if (result.status === 200) {
        } else {
          alert(result.data.reasons)
          this.errors = result.data.reasons
          this.running = false
          return
        }

        this.commit('user/setLicense', form)

        this.back()
      })
    }
  }
}
</script>
